var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-5",
        attrs: { "has-line": "", title: "Información de Vigencia" }
      }),
      _c("div", { staticClass: "row mx-2" }, [
        _c("div", { staticClass: "col-md-3 col-sm-12" }, [
          _c("span", { staticClass: "data-label" }, [_vm._v("Año Fiscal:")]),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("p", { staticClass: "data" }, [
              _vm._v(" " + _vm._s(_vm.value.fiscalYearDescription) + " ")
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-3 col-sm-12" }, [
          _c("span", { staticClass: "data-label" }, [
            _vm._v("Vigencia de Contrato Previo:")
          ]),
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("p", { staticClass: "data" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$formatDate(_vm.value.orig_EffecteFromDate)) +
                  " - " +
                  _vm._s(_vm.$formatDate(_vm.value.orig_EffectiveToDate)) +
                  " "
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-md-3 col-sm-12" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Fecha de Comienzo:")
                      ]),
                      _c("custom-date-picker", {
                        staticClass: "custom-date-picker__extended mt-1",
                        attrs: {
                          "custom-error-msg": _vm.errorMsg.dateRequired,
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          "min-date": _vm.value.orig_EffectiveToDate,
                          "open-date": _vm.openDate
                        },
                        model: {
                          value: _vm.value.effectiveFromDate,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "effectiveFromDate", $$v)
                          },
                          expression: "value.effectiveFromDate"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 col-sm-12" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("div", { staticClass: "data-label" }, [
                        _vm._v("Fecha de Finalización:")
                      ]),
                      _c("custom-date-picker", {
                        staticClass: "custom-date-picker__extended mt-1",
                        attrs: {
                          "custom-error-msg": _vm.errorMsg.dateRequired,
                          disabled: _vm.isReadOnly,
                          error: errors[0],
                          "min-date": _vm.value.orig_EffectiveToDate,
                          "open-date": _vm.openDate
                        },
                        model: {
                          value: _vm.value.effectiveToDate,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "effectiveToDate", $$v)
                          },
                          expression: "value.effectiveToDate"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }